import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NotificationService } from '../../_services/notification.service';
import { NgForm } from '@angular/forms';
import { ElasticSearchService } from '../../_services/elastic-search.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { UserService } from '../../_services/user.service';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
@Component({
  selector: 'app-comment-item',
  templateUrl: './comment-item.component.html',
  inputs: ['post', 'comment', 'index'],
  styleUrls: ['./comment-item.component.css']
})
export class CommentItemComponent implements OnInit {
  user: any;
  post: any;
  model: string;
  userId = this.userService.getUid();
  index: number;
  commentLikeCount = 0;
  private subscription: Subscription = new Subscription();
  isEdit: boolean;
  _isLiked: boolean;
  isSilencedForMe: boolean;
  @ViewChild("commentText") commentText: ElementRef;
  @ViewChild("f") form: NgForm;
  comment: any;
  constructor(private router: Router,
    private afs: AngularFirestore,
    private cd: ChangeDetectorRef,
    public notificationService: NotificationService,
    private userService: UserService,
    private elasticSearchService: ElasticSearchService) {

  }
  ngOnInit() {

    this.isSilencedUser(this.post.author.username);
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this._isLiked = this.isLiked();
  }
  focus() {
    this.commentText.nativeElement.classList.add("active");
  }
  isSilencedUser(username) {
    try {
      let array = [];
      this.afs.collection('users').doc(this.user.id).collection('silencedUser').ref.get().then((data) => {
        if (!data.empty) {
          data.forEach(silencedUser => {
            array.push(silencedUser.data());

          })
        }
      })
      this.isSilencedForMe = !array.every((data: any) => username !== data.username);
    } catch (e) {
      this.isSilencedForMe = false;
    }
  }
  submit() {
    this.isEdit = false;
    this.form.ngSubmit.emit();
  }
  commentKeyPress(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (this.model.replace(/\s/g, '')) {
        this.submit();
      }

    }
  }
  delete() {
    let post = this.post;
    let comments = post.comments.filter((comment, index) => index !== this.index)

    this.afs.collection('posts').doc(post.id).update({
      comments: comments
    });
    if (post.author.username != this.user.username) {
      this.getPoint(this.user, 'deleteComment');
    }
  }
  // commentLikeLength() {
  //   return this.comment.likes ? this.comment.likes.length : 0;
  // }
  isLiked(): boolean {
    try {
      return !this.comment.likes.every(like => like.username !== this.user.username)
    } catch (e) {
      return false;
    }
  }
  edit() {
    const user = {
      firstname: this.user.firstname,
      lastname: this.user.lastname,
      username: this.user.username
    };
    if (this.post.comments[this.index].commentLikeCount) {
      const commenty = {
        text: this.model,
        html: this.model,
        modifyDate: this.post.comments[this.index].modifyDate,
        user: this.post.comments[this.index].user,
        commentLikeCount: this.post.comments[this.index].commentLikeCount
      };

      console.log(this.model);
      let comments = this.post.comments.filter((comment, index) => index !== this.index);
      comments.push(commenty);
      comments = comments.sort(function (a, b) {
        a = a.modifyDate;
        b = b.modifyDate;
        return a > b ? 1 : a < b ? -1 : 0;
      });

      this.afs.collection('posts').doc(this.post.id).update({
        comments: comments
      });
    }
    else {
      const commenty = {
        text: this.model,
        html: this.model,
        modifyDate: this.post.comments[this.index].modifyDate,
        user: this.post.comments[this.index].user
      };

      console.log(this.model);
      let comments = this.post.comments.filter((comment, index) => index !== this.index);
      comments.push(commenty);
      comments = comments.sort(function (a, b) {
        a = a.modifyDate;
        b = b.modifyDate;
        return a > b ? 1 : a < b ? -1 : 0;
      });

      this.afs.collection('posts').doc(this.post.id).update({
        comments: comments
      });
    }




  }
  like() {

    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }

    const postInPath = {};
    const user = {
      firstname: this.user.firstname,
      lastname: this.user.lastname,
      username: this.user.username
    };
    let post = this.post;
    let comment = this.comment;
    if (!this.isLiked()) {

      const commenty = {
        text: this.post.comments[this.index].text,
        html: this.post.comments[this.index].html,
        modifyDate: this.post.comments[this.index].modifyDate,
        user: this.post.comments[this.index].user,
        commentLikeCount: (this.post.comments[this.index].commentLikeCount || 0) + 1,
        likes: [user]
      };
      let array = [];
      this.afs.collection('posts').doc(this.post.id).ref.get().then((data) => {
        data.data().comments.forEach(b => {
          if (commenty.modifyDate !== b.modifyDate) {
            array.push(b);
          }
        })
        array.push(commenty)
        array = array.sort(function (a, b) {
          a = a.modifyDate;
          b = b.modifyDate;
          return a > b ? 1 : a < b ? -1 : 0;
        });

      }).then(() => {


        this.afs.collection('posts').doc(this.post.id).update({
          comments: array
        });


        // else {
        //   this.commentLikeCount = 1;
        //   this.cd.markForCheck();
        // }

      }

      )



      if (post.author.username !== this.user.username) {
        this.afs.collection('users').ref.where('username', '==', comment.user.username).get().then((snap => {
          if (!snap.empty) {
            snap.forEach(data => {
              if (this.user.username !== post.author.username) {
                let userInfo: any = {};
                if (post.settings.isNameSecret && post.author.username == this.user.username) {
                  userInfo.firstname = "İçimizden";
                  userInfo.lastname = "Biri";
                  userInfo.profileImage = "no-image.png";
                } else {
                  userInfo.firstname = this.user.firstname;
                  userInfo.lastname = this.user.lastname;
                  userInfo.profileImage = this.user.profileImage;
                }
                const message = {
                  body: '<span><strong>' + userInfo.firstname + ' ' + userInfo.lastname + '</strong> yorumunu beğendi.</span>',
                  innerBody: userInfo.firstname + ' ' + userInfo.lastname + ' yorumunu beğendi.',
                  title: 'Beğeni',
                  click_action: 'post/' + post.id,
                  action: 'post/' + post.id,
                  postText: post.innerText,
                  postUser: post.author.firstname + " " + post.author.lastname,
                  image: userInfo.profileImage,
                  isUnseen: true,
                  modifyDate: Date.now()
                };
                this.notificationService.pushNotification(message, data.id);
              }

            })
          }

        }))

      }

      this.getPoint(comment.user, 'commentLike');
    } else {
      if (comment.likes) {
        const arrays1 = comment.likes.filter(obj => obj.username !== this.user.username);

        const commenty = {
          text: this.post.comments[this.index].text,
          html: this.post.comments[this.index].html,
          modifyDate: this.post.comments[this.index].modifyDate,
          user: this.post.comments[this.index].user,
          commentLikeCount: this.post.comments[this.index].commentLikeCount ? this.post.comments[this.index].commentLikeCount - 1 : 0,
          likes: arrays1
        };
        let array = [];
        this.afs.collection('posts').doc(this.post.id).ref.get().then((data) => {
          data.data().comments.forEach(b => {
            if (commenty.modifyDate !== b.modifyDate) {
              array.push(b);
            }
          })
          array.push(commenty)
          array = array.sort(function (a, b) {
            a = a.modifyDate;
            b = b.modifyDate;
            return a > b ? 1 : a < b ? -1 : 0;
          });

        }).then(() => {
          this.afs.collection('posts').doc(this.post.id).update({ comments: array });
        }
        )
        this.cd.markForCheck();
      }
      // this.getPoint(comment.user, 'commentUnlike');
    }


  }


  async getPoint(postUser: any, type: string) {
    let point;
    if (type === 'commentLike') {
      point = 1;
    }
    if (type === 'deleteComment') {
      point = -2;
    }
    if (type === 'commentUnLike') {
      point = -1;
    }

    this.afs.collection('users').ref.where('username', '==', postUser.username).get().then((userData) => {
      this.afs.collection('users').doc(userData.docs[0].id).update({
        point: {
          totalPoint: (userData.docs[0].data().point.totalPoint || 0) + point
        }
      });
    });


  }

  navigate(username) {
    this.router.navigate(['/']).then(() => {
      this.router.navigate(['user/' + username]);
    });
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/comment-item/comment-item.component.ts